/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Owner_PasswordInputs */

const cs_auth_signup_owner_password = /** @type {(inputs: Auth_Signup_Owner_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heslo (min. 8 znaků)`)
};

const en_auth_signup_owner_password = /** @type {(inputs: Auth_Signup_Owner_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password (min. 8 characters)`)
};

/**
* | output |
* | --- |
* | "Password (min. 8 characters)" |
*
* @param {Auth_Signup_Owner_PasswordInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_owner_password = /** @type {((inputs?: Auth_Signup_Owner_PasswordInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Owner_PasswordInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_owner_password(inputs)
	return cs_auth_signup_owner_password(inputs)
});